import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefaultReturn"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <div>
        <Responsive maxWidth={789}>
          <table className="TableCustData" >
            <colgroup>
              <col width="30%"/>
              <col width="70%"/>
              </colgroup>
            <tbody>
            {rows}
            </tbody>
          </table>
        </Responsive>
        <Responsive minWidth={790}>
        <Table className="TableCustData" style={{width:"80%"}}>
            <colgroup>
                <col width="55%"/>
                <col width="15%"/>
                <col width="15%"/>
                {/*<col width="15%"/>*/}
            </colgroup>
            <Table.Header>
                <tr>
                    <th className="tr">{translate( "Artikel" )}</th>
                    <th className="tl">{translate( "EAN" )}</th>
                    {/*<th style={{alignContent:"right",textAlign:"right"}} className="tl">{translate( "Liefermenge" )}</th>*/}
                    <th style={{alignContent:"right",textAlign:"center"}} className="tr">{translate( "Restanten" )}</th>
                    {/*<th style={{alignContent:"right",textAlign:"right"}} className="tr">{translate( "UVP" )}</th>*/}
                </tr>
            </Table.Header>
            <tbody>
            {rows}
            </tbody>
        </Table>
        </Responsive>
      </div>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductTableReturn.js